module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('box-widget', {
    attrs: {
      "icon": "phone"
    }
  }, [_c('template', {
    slot: "head"
  }, [_vm._v(_vm._s(_vm.$t('pos.lead-contacts.title'))), _c('b-btn', {
    staticClass: "float-right",
    attrs: {
      "size": "sm"
    },
    on: {
      "click": _vm.openModal
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.buttons.edit')))])], 1), _c('template', {
    slot: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h2', {
    staticClass: "box-widget-list-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('pos.lead-contacts.phones.title')))])]), _c('div', {
    staticClass: "box-widget-list-value"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('pos.lead-contacts.phones.fallback', {
    phone: _vm.customerPhone
  })))])]), _c('div', {
    staticClass: "box-widget-list-value"
  }, [_c('ul', _vm._l((_vm.campaignPhones), function(phone) {
    return _c('li', [_vm._v(_vm._s(phone))])
  }))])]), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h2', {
    staticClass: "box-widget-list-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('pos.lead-contacts.emails.title')))])]), _c('div', {
    staticClass: "box-widget-list-value"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('pos.lead-contacts.emails.fallback', {
    email: _vm.customerEmail
  })))])]), _c('div', {
    staticClass: "box-widget-list-value"
  }, [_c('ul', _vm._l((_vm.campaignEmails), function(email) {
    return _c('li', [_vm._v(_vm._s(email))])
  }))])])])])], 2), _c('b-modal', {
    ref: "modal",
    staticClass: "edit-lead-contacts-modal",
    attrs: {
      "size": "lg",
      "title": _vm.$t('pos.lead-contacts.title'),
      "fade": false,
      "closeTitle": _vm.$t('pos.buttons.close')
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h6', [_vm._v(_vm._s(_vm.$t('pos.lead-contacts.phones.title')))]), _c('span', [_vm._v(_vm._s(_vm.$t('pos.lead-contacts.phones.fallback', {
    phone: _vm.customerPhone
  })))]), _vm._l((_vm.newPhones), function(phone, index) {
    return _c('b-form-input', {
      key: index,
      attrs: {
        "type": "tel",
        "placeholder": _vm.$t('pos.lead-contacts.phones.placeholder')
      },
      model: {
        value: (_vm.newPhones[index]),
        callback: function($$v) {
          _vm.$set(_vm.newPhones, index, $$v)
        },
        expression: "newPhones[index]"
      }
    })
  })], 2), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h6', [_vm._v(_vm._s(_vm.$t('pos.lead-contacts.emails.title')))]), _c('span', [_vm._v(_vm._s(_vm.$t('pos.lead-contacts.emails.fallback', {
    email: _vm.customerEmail
  })))]), _vm._l((_vm.newEmails), function(email, index) {
    return _c('b-form-input', {
      key: index,
      attrs: {
        "type": "email",
        "placeholder": _vm.$t('pos.lead-contacts.emails.placeholder')
      },
      model: {
        value: (_vm.newEmails[index]),
        callback: function($$v) {
          _vm.$set(_vm.newEmails, index, $$v)
        },
        expression: "newEmails[index]"
      }
    })
  })], 2)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_vm._v(_vm._s(_vm.$t('pos.lead-contacts.leave-empty')))])]), _c('template', {
    slot: "modal-footer"
  }, [_c('gotu-nav-button', {
    attrs: {
      "theme": "default-cta",
      "loading": _vm.changing
    },
    on: {
      "click": _vm.changeLeadContacts
    }
  }, [_vm._v(_vm._s(_vm.$t('terms.misc.change')))]), _c('gotu-nav-button', {
    on: {
      "click": _vm.cancelModal
    }
  }, [_vm._v(_vm._s(_vm.$t('terms.misc.cancel')))])], 1)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9c0bde3a"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/lead-contact-box/LeadContactBox.vue
// module id = 2081
// module chunks = 1